import get from "lodash.get";
import { Tooltip } from "react-bootstrap";
import styled from "styled-components";

export const AdditionalMenuButton = styled("div")`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 40px;
  height: 40px;
  border-radius: 5px;
  transition: 0.2s ease all;
  cursor: pointer;
`;

export const AdditionalMenuTooltip = styled(Tooltip)`
  width: auto;
  .tooltip-inner {
    padding: 0;
    box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
    background-color: ${({ theme }) => get(theme, "background.main")};
    color: ${({ theme }) => get(theme, "black.dark")};
    .addtional-menu-list {
      .addtional-menu-item {
        padding: 8px 15px;
        cursor: pointer;
        a {
          color: ${({ theme }) => get(theme, "secondary.dark")};
          text-decoration: none;
        }
        &:hover {
          background-color: ${({ theme }) => get(theme, "background.hoverPrimary")};
        }
      }
      a {
        color: ${({ theme }) => get(theme, "secondary.dark")};
        text-decoration: none;
      }
    }
  }
  .tooltip-arrow {
    ::before {
      border-bottom-color: ${({ theme }) => get(theme, "white.light")};
    }
  }
`;
